/**
 * Only surface the "top percentile" badge for genuinely top-ranked orgs: those
 * in the top 25% or better. `percentileRank` is 0–100 where 100 is the top, so
 * top 25% means a rank of 75+.
 */
const STREAK_TOP_PERCENT_THRESHOLD = 25

/**
 * Build the streak percentile badge label (e.g. `Top 15%`) from the org's
 * `percentileRank` (0–100, 100 = top). Returns `null` — meaning "render no
 * badge" — when there's no rank yet or the org isn't in the top
 * {@link STREAK_TOP_PERCENT_THRESHOLD}%. The displayed "top X%" is
 * `100 - percentileRank`, clamped to at least 1% so we never show "Top 0%".
 *
 * Shared between the Buffer Home scorecard and the sidebar streak popover so
 * both surfaces apply the same threshold and copy.
 */
export function getStreakTopPercentLabel(
  percentileRank: number | null | undefined,
): string | null {
  if (percentileRank == null) return null

  const topPercent = Math.max(1, 100 - Math.round(percentileRank))
  if (topPercent > STREAK_TOP_PERCENT_THRESHOLD) return null

  return `Top ${topPercent}%`
}
